import { useMemo } from "react";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import {
  alpha,
  Divider,
  Flex,
  Group,
  NumberFormatter,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { IconEye, IconMessage, IconUserPlus } from "@tabler/icons-react";
import LoaderStats from "../../LoaderStats";
import ReportingInfo from "../../ReportingInfo";
import { useLanguage } from "../../../../../stores/LanguageStore";

const LinkedinSummaryTop = ({ active, setActive, isExport }) => {
  const lang = useLanguage((s) => s.language);
  const actualStats = useReportingStore((s) => s.actualStats);
  const actualStatsDate = useReportingStore((s) => s.actualStatsDate);
  const dateRange = useReportingStore((s) => s.dateRange);

  const statistics = useMemo(() => {
    if (!dateRange.start_date && !dateRange.end_date) {
      return actualStats;
    } else {
      const totals = actualStatsDate.reduce((acc, curr) => {
        Object.keys(curr).forEach((key) => {
          if (key !== "date") {
            acc[key] = (acc[key] || 0) + curr[key];
          }
        });
        return acc;
      }, {});
      return totals;
    }
  }, [dateRange.start_date, dateRange.end_date, actualStats, actualStatsDate]);

  const data = useMemo(() => {
    return [
      {
        label: lang.reports.message_sent,
        value: statistics.linkedin_message_sent,
        icon: <IconMessage />,
        type: "messages",
        info: lang.reports.message_sent_info,
      },
      {
        label: lang.reports.invitation_sent,
        value: statistics.linkedin_invitation_sent,
        icon: <IconUserPlus />,
        type: "invitations",
        info: lang.reports.invitation_sent_info,
      },
      {
        label: lang.reports.visited_profiles,
        value: statistics.linkedin_visit_profile,
        icon: <IconEye />,
        type: "visits",
        info: lang.reports.visited_profiles_info,
      },
    ];
  }, [
    lang.reports.invitation_sent,
    lang.reports.invitation_sent_info,
    lang.reports.message_sent,
    lang.reports.message_sent_info,
    lang.reports.visited_profiles,
    lang.reports.visited_profiles_info,
    statistics.linkedin_invitation_sent,
    statistics.linkedin_message_sent,
    statistics.linkedin_visit_profile,
  ]);

  return (
    <Group p={isExport ? 0 : "lg"} gap={"xl"}>
      {data.map((item) => (
        <Paper
          key={item.type}
          component={Stack}
          flex={1}
          w={300}
          p={"lg"}
          style={{ alignSelf: "stretch", boxShadow: "#00000016 0px 1px 4px" }}
          bg={"#fcfbff"}
          pos={"relative"}
        >
          <LoaderStats />
          <Group>
            <ThemeIcon
              variant="filled"
              radius={"md"}
              size={"lg"}
              color={"var(--mantine-color-blue-5)"}
            >
              {item.icon}
            </ThemeIcon>
            <Text size="lg" fw={600}>
              {item.label}
            </Text>
            <ReportingInfo>
              <Text>{item.info}</Text>
            </ReportingInfo>
          </Group>

          <Divider w={"100%"} color="gray.2" />

          <Group>
            <Flex
              align={"center"}
              justify={"center"}
              w={"100%"}
              bg={`linear-gradient(90deg, ${alpha(
                "var(--mantine-color-blue-5)",
                0.6
              )}, ${alpha("var(--mantine-color-blue-5)", 1)})`}
              fz={22}
              h={50}
              style={{ borderRadius: 12, cursor: "pointer" }}
              wrap={"nowrap"}
              c={"#fcfbff"}
              fw={600}
              onClick={() => setActive(item.type)}
            >
              <NumberFormatter value={item.value} thousandSeparator=" " />
              <Text size="md" ml={16}>
                {item.type === "visits"
                  ? lang.reports.visits
                  : lang.reports.sent}
              </Text>
            </Flex>
          </Group>
        </Paper>

        // <Paper
        //   key={item.type}
        //   component={Stack}
        //   align="center"
        //   justify="center"
        //   w={300}
        //   h={200}
        //   gap={"xs"}
        //   className={
        //     "linkedin-activity-item " + (active === item.type ? "active" : "")
        //   }
        //   onClick={() => setActive(item.type)}
        //   pos={"relative"}
        // >
        //   <LoaderStats isDate />
        //   <ThemeIcon variant="subtle" size={52}>
        //     {item.icon}
        //   </ThemeIcon>

        //   <Text fz={32}>
        //     <NumberFormatter value={item.value} />
        //   </Text>

        //   <Text size="md" fw={600}>
        //     {item.label}
        //   </Text>
        // </Paper>
      ))}
    </Group>
  );
};

export default LinkedinSummaryTop;
